import React, { useCallback } from 'react';
import { useBulkOpsSessionContext } from '@atlassian/jira-bulk-operations-analytics/src/controllers/index.tsx';
import {
	useFormStatusFlags,
	type FlagRendererProps,
} from '../../controllers/use-form-submit-state/utils.tsx';
import { OperationErrorFlag } from './flags/error-flag/index.tsx';
import { InProgressFlag } from './flags/in-progress-flag/index.tsx';
import { OperationPartialErrorFlag } from './flags/partial-error-flag/index.tsx';
import { OperationSuccessFlag } from './flags/success-flag/index.tsx';

export const useEditFormStatusFlags = () => {
	const bulkOpsFlow = useBulkOpsSessionContext();

	const renderInProgressFlag = useCallback(
		(props: FlagRendererProps) => <InProgressFlag {...props} />,
		[],
	);
	const renderSuccessFlag = useCallback(
		(props: FlagRendererProps) => <OperationSuccessFlag {...props} bulkOpsFlow={bulkOpsFlow} />,
		[bulkOpsFlow],
	);
	const renderErrorFlag = useCallback(
		(props: FlagRendererProps) => <OperationErrorFlag {...props} bulkOpsFlow={bulkOpsFlow} />,
		[bulkOpsFlow],
	);
	const renderPartialErrorFlag = useCallback(
		(props: FlagRendererProps) => (
			<OperationPartialErrorFlag {...props} bulkOpsFlow={bulkOpsFlow} />
		),
		[bulkOpsFlow],
	);
	useFormStatusFlags({
		renderInProgressFlag,
		renderSuccessFlag,
		renderErrorFlag,
		renderPartialErrorFlag,
	});
};
